import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type ConnectionsTimeframe = '7d' | '14d' | '30d' | '90d' | '180d' | '365d' | 'all';

interface ConnectionsStats {
  total: number;
  totalMutual: number;
  perDay: { date: string; mutual: number; nonMutual: number }[];
}

export function useAdminConnections(params: { timeframe: ConnectionsTimeframe }) {
  return useQuery({
    queryKey: ['admin-connections', params.timeframe],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.set('timeframe', params.timeframe);
      return api.get<ConnectionsStats>(`/admin/connections/stats?${searchParams.toString()}`);
    },
  });
}

export interface InviteStats {
  total: number;
  byEmail: number;
  byConnection: number;
  accepted: number;
  acceptedByEmail: number;
  acceptedByConnection: number;
  pending: number;
  declined: number;
  cancelled: number;
  expired: number;
  sentPerDay: { date: string; email: number; connection: number }[];
  acceptedPerDay: { date: string; email: number; connection: number }[];
}

export function useAdminInviteStats(params: { timeframe: ConnectionsTimeframe }) {
  return useQuery({
    queryKey: ['admin-invite-stats', params.timeframe],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.set('timeframe', params.timeframe);
      return api.get<InviteStats>(`/admin/invites/stats?${searchParams.toString()}`);
    },
  });
}
